import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import StrataService from "@services/StrataService";

const EditStrata = ({ strata, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [nameEng, setNameEng] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setNameEng("");
    setDescription("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    StrataService.update(strata.id, name, nameEng, description)
      .then(() => {
        showSuccess(t("strataEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal)
      StrataService.find(strata.id).then((response) => {
        setName(response.data.data.name);
        setNameEng(response.data.data.name_eng);
        setDescription(response.data.data.description);
      });
  }, [strata.id, showModal]);

  return (
    <PermissionHandler permission={"update_stratum"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editStrata")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5">
          <Input
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
            height="h-10"
          />
          <Input
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={nameEng}
            onChange={setNameEng}
            height="h-10"
          />
          <Input
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
            height="h-10"
          />
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditStrata;
